export class AwsSecretTagDto {
  
  public key: string = '';
  public value: string = ''; 

  constructor(init: { key: string, value: string }) {
    this.key = init.key;
    this.value = init.value;    
  }  
}